import { dateOnly } from 'utils/dateSchemas';
import z from 'zod';

export const ScheduledWorkOrderSchema = z.object({
    id: z.string(),
    daysRequired: z.number(),
    estimatedCompletionDate: z.string(),
    identifier: z.string(),
    latestScheduleDate: z.string(),
    notes: z.string(),
    requestedDate: dateOnly(),
    slackDays: z.number(),
    sortOrder: z.number(),
    tuid: z.string(),
    itemCount: z.number().optional(),
    workstationGroupAssignment: z
        .object({
            id: z.string(),
            name: z.string(),
            warehouseLocationId: z.string(),
        })
        .nullable(),
});

export type ScheduledWorkOrder = z.infer<typeof ScheduledWorkOrderSchema>;
